<template>
    <CModal
      :title="title+' ( '+(form.code)+' )'"
      :color="color"
      :show.sync="showModal"
      :keyboard="false"
    >
        <CForm id="document_form" method="POST" enctype="multipart/form-data">
          <CInput
            hidden
            :lazy="false"
            :value.sync="$v.form.id.$model"
            name="id"
            id="id"          
          />
          <CInput
            hidden
            :lazy="false"
            :value.sync="$v.form.code.$model"
            name="code"
            id="code"          
          />
            <CRow>
              <CCol md="12" v-if="form.image" style="text-align: center;">
                <div style="text-align: center; border: 1px solid; padding: 10px;">
                  <img :src="form.image" width="300">          
                </div>
                <br />
              </CCol>
              <CCol md="12" v-if="isEdit || form.asset_type_id > 0">
                <CSelect
                    label="Tipo:"
                    name="asset_type_id"
                    id="asset_type_id"
                    :value.sync="$v.form.asset_type_id.$model"
                    :isValid="checkIfValid('asset_type_id')"
                    :options="typesOptions"
                    invalidFeedback="Este campo es requerido."
                    :readonly="!isEdit"
                  />                            
              </CCol>  
              <CCol md="12" v-if="isEdit || form.name != ''">
                <CInput
                  label="Nombre:"
                  name="name"
                  id="name"
                  :lazy="false"
                  :value.sync="$v.form.name.$model"
                  :isValid="checkIfValid('name')"
                  placeholder=""
                  autocomplete="given-name"
                  invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
                  :readonly="!isEdit"
                />
              </CCol>
              <CCol md="8" v-if="isEdit || form.description != ''">
                <CInput
                  label="Descripción:"
                  name="description"
                  id="description"
                  :lazy="false"
                  :value.sync="$v.form.description.$model"
                  placeholder=""
                  autocomplete="given-description"
                  :readonly="!isEdit"
                />
              </CCol>  
              <CCol md="4" v-if="isEdit || form.serie != ''">
                <CInput
                  label="Serie:"
                  name="serie"
                  id="serie"
                  :lazy="false"
                  :value.sync="$v.form.serie.$model"
                  placeholder=""
                  autocomplete="given-description"
                  :readonly="!isEdit"
                />
              </CCol>      
            </CRow>
            <CRow>         
              <CCol md="12" v-if="isEdit || form.asset_departament_id > 0">
                <CSelect
                  label="Departamento:"
                  name="asset_departament_id"
                  id="asset_departament_id"
                  :value.sync="$v.form.asset_departament_id.$model"
                  :isValid="checkIfValid('asset_departament_id')"
                  :options="departamentsOptions"
                  invalidFeedback="Este campo es requerido."
                  :readonly="!isEdit"
                />                              
              </CCol>                          
              <CCol md="12" v-if="isEdit">
                <CInput
                  label="Imagen:"
                  :lazy="false"
                  :value.sync="$v.form.upload_image.$model"
                  type="file"
                  accept=".jpg,.jpeg,.png;capture=camera"
                  name="upload_image"
                  id="upload_image"
                  placeholder=""
                  autocomplete="given-image"
                />
              </CCol>     
            </CRow>
        </CForm>
        <template #footer>
          <CButton class="exit" @click="store" color="danger" v-show="isEdit">Salir</CButton>
          <CButton @click="store" :color="color" v-show="isEdit">Guardar</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, minValue, helpers } from "vuelidate/lib/validators"
import ws_typ from '../../services/asset_types';
import ws_dep from '../../services/asset_departaments';
import ws_per from '../../services/asset_persons';

export default {
  name: 'AssetModal',
  props: {
    username: String
  },
  data () {
    return {
      showModal: false,
      title: "Nuevo Activo",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,      
      typesOptions: [],
      departamentsOptions: [],
      personsOptions: [],
      qr: false,
      static: 'static'
    }
  },
  mounted: async function() {    
    let response_cat = await ws_typ.getPublic();
    if(response_cat.type == "success"){
      this.categoriesOptions = await this.$parseSelectOptionsOrdered(response_cat.data, "id", "name",[]);
    }
    let response_dep = await ws_dep.getPublic();
    if(response_dep.type == "success"){
      this.departamentsOptions = await this.$parseSelectOptionsOrdered(response_dep.data, "id", "name",[]);
    }
    let response_per = await ws_per.getPublic();
    if(response_per.type == "success"){
      this.personsOptions = await this.$parseSelectOptionsOrdered(response_per.data, "id", "name",[]);
    }

  },
  methods: {
    storeModal () {
      this.showModal = true;
      this.color = "info";
      this.title = 'Nuevo Activo';
      this.isEdit = false;
      this.submitted = false;

      let category_id = "";
      this.categoriesOptions.forEach(async (object) => {
        if(object.is_default){
          category_id = object.value;
        }
      });

      let departament_id = "";
      this.departamentsOptions.forEach(async (object) => {
        if(object.is_default){
          departament_id = object.value;
        }
      });

      this.form = {
          id: 0,
          name: '',
          description: '',
          serie: "",
          asset_type_id: type_id,
          asset_departament_id: departament_id,
          image: "",
          upload_image: ""
      }
    },
    updateModal (item) {
      this.showModal = true;
      this.color = "warning";
      this.title = 'Editar Activo';
      this.isEdit = true;
      this.submitted = false;

      this.form = {
          id: item.id,
          name: item.name,
          description: item.description,
          serie: item.serie,
          asset_type_id: item.asset_type_id,
          asset_departament_id: item.asset_departament_id,
          asset_person_id: item.asset_person_id,
          image: item.image,
          upload_image: ""
      };
    },
    qrModal (item) {
      this.showModal = true;
      this.color = "info";

      this.code = item.code;

      this.isEdit = this.username ? true : false;

      if(item.id > 0){
        this.title = 'Información del Activo';

        this.form = {
          id: item.id,
          code: item.code,
          name: item.name,
          description: item.description,
          serie: item.serie,
          asset_type_id: item.asset_type_id,
          asset_departament_id: item.asset_departament_id,
          asset_condition_id: item.asset_condition_id,
          asset_person_id: item.asset_person_id,
          image: item.image,
          upload_image: ""
        };
      }
      else{
          if(!this.isEdit){
            window.location.href = "/#/login"; return;
          }

          this.title = 'Nuevo Activo';

          let type_id = this.typesOptions[0].value;
          this.typesOptions.forEach(async (object) => {
            if(object.is_default){
              type_id = object.value;
            }
          });

          let departament_id = this.departamentsOptions[0].value;
          this.departamentsOptions.forEach(async (object) => {
            if(object.is_default){
              departament_id = object.value;
            }
          });

          this.form = {
            id: 0,
            code: item.code,
            name: '',
            description: '',
            serie: "",
            asset_type_id: type_id,
            asset_departament_id: departament_id,
            image: "",
            upload_image: ""
          }
      }
      
      
      this.submitted = false;

      this.qr = true;
    },
    store () {
      this.$v.$touch();

      if (this.isValid) {
        this.submitted = true;

        let form = document.getElementById("document_form");
        let formData = new FormData(form);


        if(this.form.id > 0){
          this.$emit("update", formData );
        }
        else{
          this.$emit("store", formData );
        }

        //this.closeModal();
      }
    },
    refreshItem (item) {
      this.form.id = item.id;
      this.form.image = item.image;
      this.title = 'Información del Activo';
    },
    preventClose(event) {
      event.preventDefault();
    },
    closeModal () {
      // this.showModal = false;

      // this.form = this.getEmptyForm()
      // this.submitted = false
      // this.$v.$reset()
    },
    getEmptyForm () {
      return {
          id: 0,
          code: '',
          name: '',
          description: '',
          serie: "",
          asset_type_id: "",
          asset_departament_id: "",
          image: "",
          upload_image: ""
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      id: {},
      code: {},
      image: {},
      upload_image: {},
      name: {
        required,
        minLength: minLength(3)
      },
      description: {},
      serie: {},
      type_id: {
        required,
        minValue: minValue(1)
      },
      asset_departament_id: {
        required,
        minValue: minValue(1)
      },
    }
  },
}
</script>
<style>
  .close{
    display: none;
  }

  .exit{
    float: left;
  }
</style>